import * as React from "react";
// import * as ReactDOMServer from 'react-dom/server';

// Centers a modal on the screen
export const centerModal = {
  left: "50%",
  position: "relative",
  top: "50%",
  transform: `translate(-${50}%, -${50}%)`,
} as React.CSSProperties;

import { ISurveyEvalResponse, TemplateType } from "../src/services";

export function hexToRGB(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}`
    : "";
}

export enum PersonType {
  coach,
  student,
  parent,
}

export function hideColumn(
  person: PersonType,
  survey: ISurveyEvalResponse,
  responses: { scale?: number[]; written?: string[] }
): boolean {
  let hide = false;
  switch (person) {
    case PersonType.coach:
      hide = survey.type === TemplateType.noGridNoCoach;
  }
  return (
    hide ||
    (responses.scale !== undefined &&
      responses.scale.filter((response) => response !== -1).length === 0) ||
    (responses.written !== undefined &&
      responses.written.filter((response) => response !== "").length === 0)
  );
}

// special case for -1
export function roundToTen(num: number): string {
  if (num === undefined) {
    return "";
  }
  if (num === -1) {
    return "no responses";
  }
  return num.toFixed(1);
}



// WEBPACK FOOTER //
// ./src/util.ts